module.exports = __webpack_public_path__ + "static/8-billboard-428239805557b2dbd41dd325c458dd69.mp4";